<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-08-11 16:31:38
 * @FilePath: \mrc-ess-fronted\src\Page\Ess\Roster\RosterFormRecord\components\selectSender.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-11-20 10:20:41
-->
<template>
  <normalDialog
    :title="
      $t('label_essweb_RosterRecordForm_form_slide_dialog_selectSenderTitle')
    "
    @close="closeDialog"
    width="600"
    :dialog="show"
  >
    <template v-slot:content>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col>
            <v-sheet class="mrc_text_require text--secondary">{{
              $t("label_essweb_RosterRecordForm_form_slide_dialog_senderLabel")
            }}</v-sheet>
            <v-autocomplete
              v-model="curSender"
              :items="SenderList"
              filled
              dense
              chips
              :filter="$staffFilter"
              hide-details
              deletable-chips
              @input="
                (val) => {
                  if (val.length > 1) {
                    //2021-04-07 Daveluo 改为单选，若要多选去掉这个function
                    curSender = curSender.slice(1, 2);
                  }
                }
              "
              small-chips
              multiple
              :rules="$GetRules(['_Require_Rules'], [null])"
              single-line
              color="primary"
              item-text="staff_code"
              item-value="staff_id"
            >
              <template v-slot:no-data>
                <noContent />
              </template>
              <template v-slot:selection="data">
                <v-chip
                  v-bind="data.attrs"
                  close
                  pill
                  :input-value="data.selected"
                  @click="data.select"
                  @click:close="removeStaff(data.item)"
                >
                  <StaffAvatar
                    left
                    contentClass="white--text"
                    :src="data.item.staff_avatar"
                    :staff_name="data.item.preferred_name"
                  />
                  {{ $getCommonLangValue(data.item.preferred_name) }}
                </v-chip>
              </template>
              <template v-slot:item="data">
                <v-list rounded width="100%" nav dense class="pa-0">
                  <v-list-item
                    rouned
                    width="100%"
                    nav
                    two-line
                    class="pa-0 ma-0"
                  >
                    <v-list-item-avatar class="ma-0 mr-2" size="36">
                      <StaffAvatar
                        size="36"
                        :src="data.item.staff_avatar"
                        :staff_name="data.item.preferred_name"
                      />
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title class="text-body-2"
                        >{{ $getCommonLangValue(data.item.preferred_name) }}
                        <span class="text--secondary text-caption-xs">{{
                          data.item.staff_code
                        }}</span></v-list-item-title
                      >
                      <v-list-item-subtitle
                        v-html="$getCommonLangValue(data.item.job_post_name)"
                      ></v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template v-slot:actions>
      <CardActions submitBtn @cancel="closeDialog" @submit="toSave" />
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "selectSenderDialog",
  props: {
    show: { default: false, type: Boolean },
    staff_uuid: { default: null, type: [String, Number] },
  },
  computed: {
    ...mapGetters(["companyLang"]),
    SenderList() {
      return this.$getSelectTrans(this.SenderListData, "shift_name");
    },
  },
  watch: {
    show(val) {
      if (val) {
        if (this.$refs["form"]) this.$refs["form"].reset();
      }
    },
    staff_uuid(val) {
      if (val) {
        this.getSenderList();
      }
    },
  },
  data() {
    return {
      SenderListData: [],
      curSender: [],
    };
  },
  mounted() {
    if (this.staff_uuid) this.getSenderList();
  },
  methods: {
    getSenderList: function () {
      this.curSender = [];
      const that = this;
      this.$Request({
        method: "POST",
        table: "x",
        url: "/approval/get-sender-list/",
        data: {
          "~staff_uuid~": this.staff_uuid,
          data_type: 5,
          uuid: -1,
        },
        type: "client",
      }).then((res) => {
        if (!res.data || res.data.length == 0) {
          that.$emit("noSender", true);
        } else {
          that.$emit("noSender", false);
        }
        if (res.data && res.data.length == 1) {
          that.curSender = [];
          // 只有一个人，不需要选择
          that.curSender.push(res.data[0].staff_id);
          // that.$emit("onSave", that.curSender);
          that.$emit("need", that.curSender);
        }
        that.SenderListData = res.data ? res.data : [];
      });
    },
    closeDialog: function () {
      this.$emit("close");
    },
    removeStaff: function (item) {
      const index = this.curSender.indexOf(item.staff_id);
      if (index >= 0) this.curSender.splice(index, 1);
    },
    toSave: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      if (this.curSender.length <= 0) {
        this.$showMessage({
          title: this.$t(
            "message_essweb_form_isMustSelectApproval_noSelectLabel"
          ),
          okText: this.$t(
            "message_essweb_form_isMustSelectApproval_toSelectBtnLabel"
          ),
          text: this.$t("message_essweb_form_isMustSelectApprovalLabel"),
          type: "warning",
        });
        return false;
      }
      this.$emit("onSave", this.curSender);
    },
  },
};
</script>
